module.exports = __webpack_public_path__ + "media/images/front/icons/info-b960e4bcf8269d7a48297e0455435501.png";